import { useEffect } from "react";

const NetworkingReferralForm = () => {
    useEffect(() => {
        if (!document.querySelector('script[src="https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://portal-widgets.lsqportal.com/assets/bootstrap-widget.js';
            script.setAttribute('data-widget-id', '27988e72-cdbf-11ef-b491-02eda0793197');
            script.setAttribute('data-version-id', 'd5b4657f-3c71-4999-af11-ba89e3b1a94f');
            script.setAttribute('data-formjs', 'https://forms.lsqportal.com/r21/js/lsq.form.js');
            script.setAttribute('data-URL', 'https://portal-widgets.lsqportal.com');
            script.setAttribute('onload', "window['___lsq-portal-widget-helpers___'].bootstrapLSQWidget(event)");
            script.Charset = 'utf-8';
        
            // Append the script to the div with id "sd"
            const widgetDiv = document.getElementById('lsq-portal-widget-27988e72-cdbf-11ef-b491-02eda0793197-d5b4657f-3c71-4999-af11-ba89e3b1a94f');
            if (widgetDiv) {
                widgetDiv.appendChild(script);
            }
        }
    }, []);

    return (
        <div id="lsq-portal-widget-27988e72-cdbf-11ef-b491-02eda0793197-d5b4657f-3c71-4999-af11-ba89e3b1a94f" className="lsq-portal-widget lsq-form-widget">
        </div>
    )
}
export default NetworkingReferralForm;